'use client'

import { DecoratorNode, $applyNodeReplacement } from 'lexical'
import MentionComponent from './MentionComponent'
import { generateObjectId } from './scriptUtils'

export class MentionNode extends DecoratorNode {
    __mentionType
    __mentionId
    __mentionName
    __mentionData
    __objectId

    static getType() {
        return 'mention'
    }

    static clone(node) {
        return new MentionNode(
            node.__mentionType,
            node.__mentionId,
            node.__mentionName,
            node.__mentionData,
            node.__key,
            node.__objectId
        )
    }

    constructor(mentionType, mentionId, mentionName, mentionData = {}, key, objectId) {
        super(key)
        this.__mentionType = mentionType
        this.__mentionId = mentionId
        this.__mentionName = mentionName
        this.__mentionData = mentionData
        this.__objectId = objectId || generateObjectId()
    }

    createDOM() {
        const span = document.createElement('span')
        span.style.display = 'inline-block'
        return span
    }

    updateDOM() {
        return false
    }

    static importJSON(serializedNode) {
        return $createMentionNode(
            serializedNode.mentionType,
            serializedNode.mentionId,
            serializedNode.mentionName,
            serializedNode.mentionData,
            serializedNode.objectId
        )
    }

    exportJSON() {
        return {
            type: 'mention',
            version: 1,
            mentionType: this.__mentionType,
            mentionId: this.__mentionId,
            mentionName: this.__mentionName,
            mentionData: this.__mentionData,
            objectId: this.__objectId,
        }
    }

    getSerializedData() {
        const type = this.__mentionType === 'character' ? 'character' : this.__mentionId
        const data = {
            id: this.__objectId,
            type,
            ...this.__mentionData,
        }
        if (this.__mentionType === 'character') {
            data.characterId = this.__mentionId
        }
        return data
    }

    getTextContent() {
        return `{${JSON.stringify(this.getSerializedData())}}`
    }

    decorate() {
        return (
            <MentionComponent
                mentionType={this.__mentionType}
                mentionId={this.__mentionId}
                mentionName={this.__mentionName}
                mentionData={this.__mentionData}
                nodeKey={this.__key}
                objectId={this.__objectId}
            />
        )
    }

    getMentionType() {
        return this.__mentionType
    }

    getMentionId() {
        return this.__mentionId
    }

    getMentionName() {
        return this.__mentionName
    }

    getMentionData() {
        return this.__mentionData
    }

    getObjectId() {
        return this.__objectId
    }

    isInline() {
        return true
    }

    isIsolated() {
        return true
    }
}

export function $createMentionNode(mentionType, mentionId, mentionName, mentionData = {}, objectId) {
    const node = new MentionNode(mentionType, mentionId, mentionName, mentionData, undefined, objectId)
    return $applyNodeReplacement(node)
}

export function $isMentionNode(node) {
    return node instanceof MentionNode
}
